<template>
  <div class="user-management">
    <!-- 搜索和操作区域 -->
    <div class="search-filter card-panel">
      <el-form :model="searchForm" size="small" class="custom-form" inline>
        <div class="filter-container">
          <div class="search-inputs">
            <el-form-item label="用户账号">
              <el-input v-model="searchForm.username" placeholder="账号" clearable />
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="searchForm.name" placeholder="姓名" clearable />
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="searchForm.phone" placeholder="手机号" clearable />
            </el-form-item>
            <el-form-item class="form-btns">
              <el-button type="primary" icon="el-icon-search" @click="searchUsers">搜索</el-button>
              <el-button icon="el-icon-refresh" class="reset-btn" @click="resetSearch">重置</el-button>
            </el-form-item>
          </div>
          <div class="action-btns">
            <el-button type="primary" size="small" icon="el-icon-plus" class="add-btn" @click="handleAddUser">新增用户</el-button>
          </div>
        </div>
      </el-form>
    </div>
    
    <!-- 用户列表表格 -->
    <div class="table-container card-panel">
      <el-table 
        :data="userList" 
        style="width: 100%" 
        v-loading="loading" 
        element-loading-background="rgba(10, 14, 26, 0.8)"
        class="custom-table"
      >
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="username" label="用户账号" min-width="110" align="center" />
        <el-table-column prop="name" label="姓名" min-width="100" align="center" />
        <el-table-column prop="phone" label="手机号" min-width="130" align="center">
          <template slot-scope="scope">
            <span class="phone-text">{{ scope.row.phone || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="role" label="角色" min-width="100" align="center">
          <template slot-scope="scope">
            <div :class="['role-tag', scope.row.role]">
              {{ scope.row.role === 'admin' ? '管理员' : '普通用户' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="170" align="center">
          <template slot-scope="scope">
            <span class="time-text">{{ scope.row.createdAt }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" class="edit-link" @click="handleEditUser(scope.row)">编辑</el-button>
            <el-button 
              type="text" 
              icon="el-icon-delete" 
              class="delete-link"
              @click="handleDeleteUser(scope.row)" 
              :disabled="scope.row.role === 'admin'">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background>
        </el-pagination>
      </div>
    </div>
    
    <!-- 新增/编辑用户对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      append-to-body
      custom-class="custom-dialog">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="90px" class="dialog-form">
        <el-form-item label="用户账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户账号" :disabled="isEdit" />
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!isEdit">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="form.role" placeholder="请选择角色" style="width: 100%">
            <el-option label="管理员" value="admin" />
            <el-option label="普通用户" value="user" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="medium" :loading="submitLoading" class="confirm-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserManagement',
  props: {
    companyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      userList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        username: '',
        name: '',
        phone: '',
        role: ''
      },
      dialogVisible: false,
      dialogTitle: '新增用户',
      isEdit: false,
      form: {
        id: '',
        username: '',
        password: '',
        name: '',
        phone: '',
        role: 'user'
      },
      rules: {
        username: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    companyId: {
      handler() {
        this.getUserList();
      },
      immediate: true
    }
  },
  methods: {
    getUserList() {
      this.loading = true;
      setTimeout(() => {
        const mockData = [
          { id: 1, username: 'admin', name: '系统管理员', phone: '13800138000', role: 'admin', createdAt: '2024-01-01 12:00:00' },
          { id: 2, username: 'zhangsan', name: '张三', phone: '13800138001', role: 'user', createdAt: '2024-02-01 09:30:00' },
          { id: 3, username: 'lisi', name: '李四', phone: '13800138002', role: 'user', createdAt: '2024-02-05 14:20:00' },
          { id: 4, username: 'wangwu', name: '王五', phone: '13800138003', role: 'user', createdAt: '2024-02-10 10:15:00' },
          { id: 5, username: 'zhaoliu', name: '赵六', phone: '13800138004', role: 'user', createdAt: '2024-02-15 16:45:00' },
          { id: 6, username: 'sunqi', name: '孙七', phone: '13800138005', role: 'user', createdAt: '2024-02-20 11:00:00' },
          { id: 7, username: 'zhouba', name: '周八', phone: '13800138006', role: 'user', createdAt: '2024-02-25 13:30:00' },
          { id: 8, username: 'wujiu', name: '吴九', phone: '13800138007', role: 'user', createdAt: '2024-03-01 08:50:00' },
          { id: 9, username: 'zhengshi', name: '郑十', phone: '13800138008', role: 'user', createdAt: '2024-03-05 15:10:00' },
          { id: 10, username: 'test01', name: '测试用户01', phone: '13800138009', role: 'user', createdAt: '2024-03-10 17:20:00' },
          { id: 11, username: 'test02', name: '测试用户02', phone: '13800138010', role: 'user', createdAt: '2024-03-15 09:00:00' }
        ];
        
        let filteredData = [...mockData];
        if (this.searchForm.username) {
          filteredData = filteredData.filter(user => user.username.toLowerCase().includes(this.searchForm.username.toLowerCase()));
        }
        if (this.searchForm.name) {
          filteredData = filteredData.filter(user => user.name.includes(this.searchForm.name));
        }
        if (this.searchForm.phone) {
          filteredData = filteredData.filter(user => user.phone.includes(this.searchForm.phone));
        }
        if (this.searchForm.role) {
          filteredData = filteredData.filter(user => user.role === this.searchForm.role);
        }
        
        this.total = filteredData.length;
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.userList = filteredData.slice(start, end);
        this.loading = false;
      }, 600);
    },
    searchUsers() {
      this.currentPage = 1;
      this.getUserList();
    },
    resetSearch() {
      this.searchForm = {
        username: '',
        name: '',
        phone: '',
        role: ''
      };
      this.currentPage = 1;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    },
    handleAddUser() {
      this.dialogTitle = '新增用户';
      this.isEdit = false;
      this.form = {
        id: '',
        username: '',
        password: '',
        name: '',
        phone: '',
        role: 'user'
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    handleEditUser(row) {
      this.dialogTitle = '编辑用户';
      this.isEdit = true;
      this.form = {
        id: row.id,
        username: row.username,
        password: '',
        name: row.name,
        phone: row.phone,
        role: row.role
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          setTimeout(() => {
            this.$message({
              type: 'success',
              message: this.isEdit ? '更新用户信息成功' : '新增用户成功'
            });
            this.submitLoading = false;
            this.dialogVisible = false;
            this.getUserList();
          }, 800);
        }
      });
    },
    handleDeleteUser(row) {
      if (row.role === 'admin') {
        this.$message.error('管理员账号禁止删除！');
        return;
      }
      this.$confirm(`确定要删除用户 "${row.name} (${row.username})" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom-message-box'
      }).then(() => {
        this.loading = true;
        setTimeout(() => {
          this.$message.success('删除成功');
          this.getUserList();
        }, 600);
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.user-management {
  padding: 20px;
  background-color: #0a0e1a;
  min-height: 100%;
  width: 100%;
  color: #e1e5eb;
  box-sizing: border-box;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
}

/* 通用卡片面板 */
.card-panel {
  background: rgba(26, 35, 50, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.15);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.card-panel:hover {
  border-color: rgba(0, 212, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 212, 255, 0.1);
}

/* 搜索区域优化 - 强制单行 */
.search-filter {
  padding: 15px 20px;
}

.filter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.search-inputs {
  display: flex;
  align-items: center;
  flex-wrap: nowrap; /* 强制不换行 */
  gap: 12px;
}

.custom-form ::v-deep .el-form-item {
  margin-bottom: 0;
  margin-right: 0;
  display: flex;
  align-items: center;
}

.custom-form ::v-deep .el-form-item__label {
  color: #a0aec0;
  font-weight: 500;
  padding: 0 8px 0 0;
  line-height: 32px;
}

.custom-form ::v-deep .el-input__inner {
  background-color: rgba(13, 20, 30, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 4px;
  transition: all 0.3s;
  width: 140px; /* 缩小宽度以适应单行 */
}

.custom-form ::v-deep .el-input__inner:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.2);
}

.form-btns {
  display: flex;
  gap: 8px;
  margin-left: 8px;
}

.reset-btn {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #a0aec0 !important;
}

.reset-btn:hover {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

.add-btn {
  background: linear-gradient(135deg, #00d4ff 0%, #008cff 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
  padding: 8px 16px;
}

.add-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.4);
}

/* 表格区域 */
.table-container {
  padding: 1px;
  overflow: hidden;
}

.custom-table {
  background-color: transparent !important;
  border: none !important;
}

.custom-table ::v-deep tr {
  background-color: transparent !important;
}

.custom-table ::v-deep th {
  background-color: rgba(19, 25, 36, 0.8) !important;
  color: #00d4ff;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1) !important;
  text-transform: uppercase;
  font-size: 13px;
  padding: 14px 0;
}

.custom-table ::v-deep td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 10px 0;
  color: #cbd5e0;
}

.custom-table ::v-deep .el-table__row:hover td {
  background-color: rgba(0, 212, 255, 0.05) !important;
}

/* 角色标签 */
.role-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.role-tag.admin {
  background: rgba(245, 108, 108, 0.15);
  color: #f56c6c;
  border: 1px solid rgba(245, 108, 108, 0.3);
}

.role-tag.user {
  background: rgba(0, 212, 255, 0.15);
  color: #00d4ff;
  border: 1px solid rgba(0, 212, 255, 0.3);
}

.phone-text {
  color: #a0aec0;
  font-weight: 500;
}

.time-text {
  color: #718096;
  font-family: "Courier New", Courier, monospace;
}

/* 操作按钮 */
.edit-link {
  color: #00d4ff !important;
}

.delete-link {
  color: #f56c6c !important;
}

.delete-link.is-disabled {
  color: #4a5568 !important;
}

/* 分页 */
.pagination-wrapper {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: rgba(255, 255, 255, 0.05);
  color: #a0aec0;
}

.pagination-wrapper ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00d4ff;
  color: #fff;
}

/* 弹窗样式 */
::v-deep .custom-dialog {
  background: #161d29;
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 12px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: #fff;
}

::v-deep .custom-dialog .el-input__inner {
  background-color: rgba(10, 14, 26, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
}

.dialog-footer {
  padding: 0 24px 24px;
  text-align: right;
}

.cancel-btn {
  background: transparent !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #a0aec0 !important;
}

.confirm-btn {
  background: linear-gradient(135deg, #00d4ff 0%, #008cff 100%) !important;
  border: none !important;
}

/* 消息确认框 */
::v-deep .custom-message-box {
  background-color: #161d29 !important;
  border: 1px solid rgba(0, 212, 255, 0.2) !important;
}

::v-deep .custom-message-box .el-message-box__title,
::v-deep .custom-message-box .el-message-box__content {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user.vue